<template>
<div v-loading="isLoading">
  <el-select
    v-if="!allEvents"
    filterable
    class="select-primary"
    size="large"
    placeholder="Selecione ..."
    v-model="eventIdSelected"
    name="eventIdSelected"
  >
    <el-option
      class="select-primary"
      value=""
      label=""
    ></el-option>
    <el-option
      v-for="item in events"
      filterable
      class="select-primary"
      :value="item._id"
      :label="`${item.reference} - ${item.city}`"
      :key="item._id"
    ></el-option>
  </el-select>


  <button
    @click="handleCommand()"
    class="btn btn-success btn-fill btn-wd"
    title="Este botão irá enviar os dados dos tickets contemplados para o banco de contemplados"
  >
    Migrar Tickets Ganhadores para o banco de CONTEMPLADOS
  </button>
  <p>
    <input
      type="checkbox"
      v-model="allEvents"
    > Todos os eventos?

  </p>
  <el-progress :percentage="progressPercentage"/>
</div>
</template>
<script>
import swal from 'sweetalert2'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'MigrateTicketsWinnersToWinnersDb',
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 0,
      eventIdSelected: '',
      customers: [],
      allEvents: false
    }
  },
  computed: {
    ...mapGetters('events', {events: 'sortedByReference'}),
    ...mapGetters('tickets', {tickets: 'tickets'}),
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    ...mapActions('events', {fetchEvents: 'fetchAll'}),
    ...mapActions('tickets', {fetchTickets: 'fetchAll'}),
    ...mapActions('customers', {fetchCustomers: 'fetchAll'}),
    ...mapActions('winners', {insertManyWinners: 'insertMany'}),
    async handleCommand () {
      this.isLoading = true
      this.total = 0
      this.progress = 0
      try {
        let events = []
        if (!this.allEvents) {
          await this.fetchTickets({
            where: {eventId: this.eventIdSelected, winner: true},
            select: ['customerId', 'updatedAt'],
            limit: 88888
          })
        } else {
          await this.fetchTickets({
            where: {winner: true},
            select: ['customerId', 'updatedAt'],
            limit: 88888
          })
        }

        this.total = this.tickets.length

        this.isLoading = false
        if (this.total === 0) {
          this.notifyFinish()
        } else {
          this.notifyAmount()
            .then(() => {
              try {
                this.initExec(events)
              } catch (e) {
                console.log('Falha no processo', e)
              }
            })
        }
      } catch (e) {
        console.log(e)
        this.isLoading = false
      }
    },

    initExec (events) {
      swal({
        title: 'Atenção',
        text: `Todos os Tickets Contemplados vão ser migrados agora.`,
        type: 'warning',
        confirmButtonText: 'Iniciar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.exec(events)
          return 'ok'
        }
      }).then(() => {
        setTimeout(function () {
          location.reload()
        }, 3000)
        swal({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        })
      })
    },

    async exec () {
      this.customers = await this.fetchCustomers({
        where: {
          $or: this.tickets.map(item => {
            return {
              _id: item.customerId
            }
          })
        },
        select: ['_id', 'uc', 'name', 'cpf'],
        limit: 9999
      })
      this.customers = this.customers.map(customer => {
        customer.exchangeDate = this.tickets.find(item => item.customerId === customer._id).updatedAt
        customer.cpf = customer.cpf.replace(/\D/g, '')
        delete customer._id
        return customer
      })
      this.insertManyWinners(this.customers)
    },

    notifyAmount () {
      return swal({
        title: 'Eventos',
        html: `Deseja migrar dados dos ${this.total} tickets contemplados?`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, migrar os dados!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    notifyFinish () {
      this.total = 1
      this.progress = 1
      this.eventLamps = 1
      swal({
        title: 'Sucesso',
        text: `Todos os contemplados foram migrados com sucesso`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    }
  },

  mounted () {
    this.fetchEvents({limit: 9999})
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/MigrateTicketsWinnersToWinnersDb.vue